import axios from 'axios';

// API doesn't accept X-CSRF-TOKEN as a header
axios.defaults.headers.common = {
  'Content-Type': 'application/json',
  Accept: 'application/json, text/json, application/xml, text/xml',
};

import { FETCH_RESULTS } from './mutations';

const actions = {
  [FETCH_RESULTS]({ commit, state }) {
    commit({ type: 'setLoading', payload: true });

    let endpoint = `${state.API_ENDPOINT}?query=${state.term}`;

    if (state.author) {
      endpoint += `&author=${state.term}`;
    }

    axios.get(endpoint).then(data => {
      commit({ type: FETCH_RESULTS, payload: data });
      commit({ type: 'setLoading', payload: false });
    });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/global-search/actions.js